import React, {Component} from 'react';
import ErrorComponent from '../errorComponent';
import NewsList from './newsList';
import Loader from '../loader';

const BASE_URI = 'https://www.uvm.edu/uvmnews/';

class NewsItems extends Component {
  state = {
    loading: true,
    error: false,
    data: {},
    currentData: {},
    count: 0,
    offset: 0,
    page: 0,
  }

  handleErrors(response) {
    // Check for !200 response
    if (!response.ok) {
      throw Error(response.status);
    }
    return response;
  }

  handleNextPage = () => {
    const currentData = this.state.data.nodes.slice(this.state.offset, this.state.offset + this.state.count);
    const offset = this.state.offset + this.state.count;
    this.setState({ currentData, offset });
    // If not enough for 2 more pages, get more data
    if (offset + this.state.count * 2 > this.state.data.nodes.length) {
      this.getMoreData()
    }
  }

  handlePrevPage = () => {
    let offset = this.state.offset - this.state.count * 2;
    const currentData = this.state.data.nodes.slice(offset, this.state.count + offset);
    offset = offset + this.state.count;
    this.setState({ currentData, offset });
  }

  getMoreData() {
    const full_path = BASE_URI + this.props.config.field_news_category + '/group-news.json?page=' + (this.state.page + 1);
    fetch(full_path)
      .then(this.handleErrors) // handles response errors like 404
      .then((response) => response.json())
      .then((data) => this.concatData(data))
      .catch((error) => this.setState({ loading: false, error })); // Handles request errors like CORS
    this.setState({page: this.state.page + 1 });
  }

  concatData(data) {
    const newData = {
      nodes: this.state.data.nodes.concat(data.nodes),
    }
    this.setState({data: newData}); 
  }

  cleanupData(data) {
    let currentData = {};
    let offset = 0;
    if (this.props.config.field_integer_1) {
      offset = parseInt(this.props.config.field_integer_1);
    }
    const count = parseInt(this.props.config.field_news_item_count);
    // Slice to count with offset if exists
    currentData = data.nodes.slice(offset, count + offset);
    offset = count + offset;
    this.setState({ loading: false, data, currentData, count, offset });
    return data;
  }

  componentDidMount() {
    const full_path = BASE_URI + this.props.config.field_news_category + '/group-news.json';
    fetch(full_path)
      .then(this.handleErrors) // handles response errors like 404
      .then((response) => response.json())
      .then((data) => this.cleanupData(data))
      .catch((error) => this.setState({ loading: false, error })); // Handles request errors like CORS 
  }

  render() {
    const { loading, error, currentData } = this.state;
    const { field_news_display_style, field_text_1 } = this.props.config;
    return (
      loading ? <Loader /> : error ? <ErrorComponent error={error} /> : 
      <NewsList data={currentData} title={field_text_1} layout={field_news_display_style} nextPage={this.handleNextPage} prevPage={this.handlePrevPage} back={this.state.offset - this.state.count > 0} />
    );
  }
}

export default NewsItems;